module.exports = __webpack_public_path__ + "static/media/012-Erkundigen_oV_ID_16.2ca5ff7f.mp3";